import { useQuery } from '@apollo/client'
import { ThumbUpOffAlt } from '@mui/icons-material'
import { Avatar, Box, Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { GetVideoSatisfiedNumDocument } from '~/__generated__/graphql'
import { Colors } from '~/libs/mui/color'

interface VideoInfoProps {
  id: string
  creator: {
    name?: string
    avatarUrl?: string
  }
  duration: string
  description: string
  showLike?: boolean
}

/**
 * クリエイター情報・動画内容・再生時間を表記するコンポーネント
 */
export const VideoInfo = ({
  id,
  creator,
  duration,
  description,
  showLike = false,
}: VideoInfoProps) => {
  const { data } = useQuery(GetVideoSatisfiedNumDocument, {
    variables: { videoId: id },
  })

  return (
    <Box>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' gap={1} justifyContent='center'>
          <Avatar src={creator.avatarUrl} />
          <Box>
            <Typography sx={{ color: Colors.color5A5957 }} fontSize='10px'>
              <Trans i18nKey='creator' />
            </Typography>
            <Typography sx={{ color: Colors.color91908F }}>{creator.name}</Typography>
          </Box>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='flex-start'
          justifyContent='center'
          color={Colors.color91908F}
        >
          {showLike && (
            <Stack
              direction='row'
              alignItems='flex-end'
              sx={{
                color: Colors.color91908F,
                gap: 0.5,
                minWidth: 0,
                minHeight: 0,
              }}
            >
              <ThumbUpOffAlt />
              <Typography>{data?.originalVideo?.satisfiedNum}</Typography>
            </Stack>
          )}
          <Typography>{duration}</Typography>
        </Box>
      </Box>
      <Typography mt={1}>{description}</Typography>
    </Box>
  )
}
